import { Collapse } from "antd";
import { StarFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useTranslation } from "../../i18n/LanguageContext";
import "./style.css";

const BecomePartner = () => {
    const { t } = useTranslation();

    const items = t("partner.why").map((item, i) => ({
        key: String(i),
        label: item.label,
        extra: <StarFilled style={{ color: "#FF7B00" }} />,
        children: item.text ? (
            <p style={{ paddingInlineStart: 24 }}>{item.text}</p>
        ) : null,
    }));

    return (
        <div className="main-content-wrapper">
            <div className="becomePartnerPage">
                <h2>{t("page.becomePartner.title")}</h2>
                <p>{t("partner.intro")}</p>
                <h3>{t("partner.whyTitle")}</h3>
                <Collapse
                    className="collapseAbout"
                    items={items}
                    bordered={false}
                    accordion
                    collapsible={"header"}
                />
                <h3>{t("partner.formsTitle")}</h3>
                <p>{t("partner.forms")}</p>
                <Link to="/registerOrganization" className="joinBtn">
                    {t("partner.cta")}
                </Link>
            </div>
        </div>
    );
};

export default BecomePartner;
